import { Modal } from 'react-bootstrap'
import { t } from 'ttag'
import CopyToClipboard from 'react-copy-to-clipboard'
import { useCallback, useState } from 'react'

import educatorsCode from '@h2/assets/svg/icons/educatorsCode.svg'
import externalLinkAlt from '@h2/assets/svg/icons/externalLinkAlt.svg'

const selectionType = {
  LINK: 'link',
  CODE: 'code'
}
const CopyToClip = ({ text, styledText, style = {}, onCopy, isCopied }) => {
  const preventDefaultFunction = useCallback(event => event.preventDefault(), [])

  return (
    <CopyToClipboard text={text} onCopy={onCopy}>
      <div>
        <a
          href={text}
          onClick={preventDefaultFunction}
          className="btn btn-default btn-full no-style"
          style={{ lineHeight: '2rem', minHeight: '50px', ...style }}>
          {styledText || text}&nbsp;
          <i className="copy" aria-hidden="true"></i>{' '}
          <span className="sr-only">{t`Copy to clipboard`}</span>
        </a>
        {isCopied && (
          <p
            className="text-center"
            style={{
              fontStyle: 'italic',
              fontSize: '.9rem',
              color: 'green',
              marginTop: '5px'
            }}>
            {t`Copied to Clipboard`}
          </p>
        )}
      </div>
    </CopyToClipboard>
  )
}
const EducatorCodeExplanationModal = ({ show, toggleVisibility, management }) => {
  const [selectedId, setSelectedId] = useState(null)
  const copyLinkFunction = useCallback(
    () => setSelectedId(selectionType.LINK),
    [setSelectedId]
  )
  const copyCodeFunction = useCallback(
    () => setSelectedId(selectionType.CODE),
    [setSelectedId]
  )

  return (
    <Modal show={show} bsSize="lg" onHide={toggleVisibility}>
      <Modal.Header style={{ color: 'white', fontWeight: 'bold' }}>
        <button
          type="button"
          className="close"
          aria-label="Close"
          onClick={toggleVisibility}>
          <span aria-hidden="true">×</span>
        </button>
        <h2 className="modal-title">{t`About Your Navigator Code`}</h2>
      </Modal.Header>
      <Modal.Body>
        <div>
          <p
            style={{
              fontSize: '1.6rem'
            }}>
            {t`Your navigator code will allow explorers to connect their accounts to yours so that you can track their progress and report on their work.`}
          </p>
          <div className="with-border note-color">
            <h4
              className="text-center"
              style={{
                fontWeight: 'bold',
                color: 'black'
              }}>
              {t`There are two ways you can distribute your code:`}
            </h4>
            <div className="row">
              <div className="col-md-6 col-xs-12">
                <h3 className="section-heading" style={{ lineHeight: '50px' }}>
                  <img
                    aria-hidden={true}
                    alt={t`Educator Code Illustration`}
                    src={educatorsCode}
                    style={{ width: '50px', marginRight: '5px' }}
                    className="pull-left hidden-sm"
                  />{' '}
                  {t`Just the Code`}
                </h3>

                {management && (
                  <div style={{ marginBottom: '15px', minHeight: '50px' }}>
                    <CopyToClip
                      text={management.code?.toUpperCase()}
                      isCopied={selectedId === selectionType.CODE}
                      onCopy={copyCodeFunction}
                      styledText={(
                        <div
                          className="text-center"
                          style={{
                            marginBottom: '0',
                            display: 'inline',
                            fontSize: '1.6rem',
                            textTransform: 'uppercase',
                            fontWeight: 'bold'
                          }}>
                          {management.code}
                        </div>
                      )}
                    />
                  </div>
                )}
                <p>{t`The code can be easily distributed so explorers can either enter it during registration, or in the career hub.`}</p>
              </div>
              <div className="col-md-6 col-xs-12">
                <h3 className="section-heading" style={{ lineHeight: '50px' }}>
                  <img
                    aria-hidden={true}
                    alt={t`Magic Link Illustration`}
                    src={externalLinkAlt}
                    style={{ width: '50px', marginRight: '5px' }}
                    className="pull-left hidden-sm"
                  />{' '}
                  {t`Via Magic Link`}
                </h3>
                {management && (
                  <div style={{ marginBottom: '15px', minHeight: '50px' }}>
                    <CopyToClip
                      text={management.magicLink}
                      isCopied={selectedId === selectionType.LINK}
                      onCopy={copyLinkFunction}
                    />
                  </div>
                )}
                <p>{t`The link above can be e-mailed to users or distributed however you would like.`}</p>
                <p>{t`After accessing your link, users will be asked to sign in or register so they can accept you as their account manager.`}</p>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default EducatorCodeExplanationModal
